import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/logo.png';
import _imports_1 from '../assets/img/home/message.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4ebd5933"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "header"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "智慧党建安全平台", -1);
});

var _hoisted_4 = {
  class: "meun"
};
var _hoisted_5 = ["onMouseenter"];
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  class: "semeunlist"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  key: 0,
  style: {
    "padding-top": "34px",
    "padding-left": "10px"
  }
};
var _hoisted_10 = {
  class: "hint"
};
var _hoisted_11 = {
  key: 0,
  class: "My-Footer"
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "版权所有：北京北信源股份软件有限公司", -1);
});

var _hoisted_13 = [_hoisted_12];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_el_badge = _resolveComponent("el-badge");

  var _component_el_row = _resolveComponent("el-row");

  var _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 11,
        class: "logo"
      }, {
        default: _withCtx(function () {
          return [_hoisted_2, _hoisted_3];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 13
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meunList, function (item, index) {
            return _withDirectives((_openBlock(), _createElementBlock("li", {
              key: index,
              class: "meunLi",
              onMouseenter: function onMouseenter($event) {
                return _ctx.enter(index);
              },
              onMouseleave: _cache[0] || (_cache[0] = function ($event) {
                return _ctx.leave();
              })
            }, [_createElementVNode("p", {
              onClick: function onClick($event) {
                return _ctx.loginjump(item);
              }
            }, _toDisplayString(item.columnName), 9, _hoisted_6), _withDirectives(_createElementVNode("ol", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, function (items, indexs) {
              return _withDirectives((_openBlock(), _createElementBlock("li", {
                key: indexs,
                onClick: function onClick($event) {
                  return _ctx.jump(items, item);
                }
              }, _toDisplayString(items.columnName), 9, _hoisted_8)), [[_vShow, items.flag]]);
            }), 128))], 512), [[_vShow, _ctx.activeIndex == String(index)]])], 40, _hoisted_5)), [[_vShow, item.flag]]);
          }), 128)), _ctx.isLogin && _ctx.noticeFlag ? (_openBlock(), _createElementBlock("li", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_ctx.isLogin ? (_openBlock(), _createBlock(_component_el_badge, {
            key: 0,
            value: _ctx.beageNumber,
            hidden: _ctx.beageNumber == 0,
            type: "warning"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("img", {
                src: _imports_1,
                onClick: _cache[1] || (_cache[1] = //@ts-ignore
                function () {
                  return _ctx.Djump && _ctx.Djump.apply(_ctx, arguments);
                })
              })];
            }),
            _: 1
          }, 8, ["value", "hidden"])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("li", {
            class: "meunLi index-login",
            onClick: _cache[2] || (_cache[2] = //@ts-ignore
            function () {
              return _ctx.changeLogin && _ctx.changeLogin.apply(_ctx, arguments);
            })
          }, [_createElementVNode("p", null, _toDisplayString(_ctx.isLogin ? "切换" : "登录"), 1)])])];
        }),
        _: 1
      })];
    }),
    _: 1
  })]), _createElementVNode("div", {
    class: _normalizeClass({
      content: true,
      con: _ctx.$route.name != 'index'
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.$route.name == 'index' ? '' : 'maxhome')
  }, [_createVNode(_component_router_view, {
    key: _ctx.$router
  }, {
    default: _withCtx(function (_ref) {
      var Component = _ref.Component;
      return [(_openBlock(), _createBlock(_KeepAlive, {
        include: _ctx.keepRoute
      }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1032, ["include"]))];
    }),
    _: 1
  })], 2)], 2), _ctx.$route.name != 'index' ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13)) : _createCommentVNode("", true)], 64);
}